// actions.js

import axios from 'axios';
import Cookies from 'js-cookie';


export default {

    async getController({ commit, state, rootState, rootGetters }, { id }) {

        const access_token = rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };

        try {
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/controllers/${id}`, config);
            return response.data;
        } catch (error) {
            return error;
        }
    },   
    
    async getControllersBySite({ commit, state, rootState, rootGetters }, { id }) {

        const access_token = rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };

        try {
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/controllers/by-site/${id}`, config);
            console.log('Отфетчили', response.data)
            commit('updateControllerList', response.data)
            return response.data;
        } catch (error) {
            return error;
        }
    },

    async updateController({ commit, state, rootState, rootGetters }, payload) {
        const access_token = rootGetters.access_token;

        try {
            const response = await axios.put(
                `${process.env.VUE_APP_APIGATEWAY}/api/v1/controllers/${payload.id}`,
                {
                    name: payload.name,
                    site_id: payload.site_id,
                    mac_address: payload.mac_address,
                    port: payload.port,
                    rhg_id: payload.rhg_id
                },
                {
                    headers: {
                        'Authorization': `${access_token}`
                    }
                }
            );

            return {
                status: response.status,
                data: response.data
            };
        } catch (error) {
            if (error.response) {
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Update failed'
                };
            } else if (error.request) {
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                return {
                    status: -1,
                    message: error.message
                };
            }
        }
    }

};
